import { render, staticRenderFns } from "./ModelsSelect.vue?vue&type=template&id=02523778&"
import script from "./ModelsSelect.vue?vue&type=script&lang=js&"
export * from "./ModelsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports